export const getUnscramblerResults = async (axios, config, params = {}) => {
	return await axios
		.get(`${config.API_SERVICE}/v1/unscrambler`, { params })
		.then((response) => (response.status === 200 ? response.data : {}))
		.catch((err) => {
			if (err.response.status === 404) {
				return {};
			}

			console.error(
				"Could not connect to the unscrambler results endpoint. ",
				err
			);

			return {};
		});
};

export const getWordlistResults = async (axios, config, params = {}) => {
	return await axios
		.get(`${config.API_SERVICE}/v1/wordlist`, { params })
		.then((response) => (response.status === 200 ? response.data : {}))
		.catch((err) => {
			if (err.response.status === 404) {
				return {};
			}

			console.error(
				"Could not connect to the wordlist results endpoint. ",
				err
			);

			return {};
		});
};
